{
  "version": 1,
  "asset_id": "4e84729c-2bd8-4fcd-9a25-44f7d3d5bf0b",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4e84729c-2bd8-4fcd-9a25-44f7d3d5bf0b/hiatal-type-3-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4e84729c-2bd8-4fcd-9a25-44f7d3d5bf0b/hiatal-type-3-v3-800.jpg",
  "original_filename": "hiatal-type-3-v3-800.jpg",
  "size": 129952,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T22:48:16Z"
}
